export default __webpack_public_path__ + "static/media/tablog.a13e3cb2.svg";